module.exports = __webpack_public_path__ + "static/media/store.fc55566c.svg";